import { render, staticRenderFns } from "./CourseRequestDetail.vue?vue&type=template&id=224bece0"
import script from "../../services/student/course-request-detail.js?vue&type=script&lang=js&external"
export * from "../../services/student/course-request-detail.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports